import { configureStore } from "@reduxjs/toolkit";
import feedbackSlice from "./feedback";
import imagesSlice from "./images";
import image_upload_slice from "./image_upload";
import video_upload_slice from "./video_upload"

const store = configureStore({
    reducer: {
      feedbackStore:feedbackSlice,
      imagesStore:imagesSlice,
      imageUploadStore:image_upload_slice,
      videouploadStore:video_upload_slice
    },
  });
  
  
export default store;